import type { OnboardingConfiguration } from '~/onboarding/hooks/useOnboarding/OnboardingProvider';

export const TARGET_SELECTORS = {
  createFromAnywhere: 'createFromAnywhere',
};

export const config: OnboardingConfiguration = {
  featureId: 'createFromAnywhere',
  stepIds: ['create-from-anywhere-hotspot'],
  options: {
    storage: { type: 'none' },
  },
};
